/* Shared destination-aware estimates. Wall dates use Europe/Amsterdam; UTC arithmetic avoids DST drift. */
(function () {
  'use strict';
  function windowFor(country) {
    return country === 'NL' ? [1, 1] : country === 'BE' ? [1, 2] : country === 'DE' || country === 'FR' ? [2, 4] : [3, 5];
  }
  function calculate(country, now, weekdaysOnly) {
    var parts = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Amsterdam',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',hourCycle:'h23'}).formatToParts(now);
    var p = {}; parts.forEach(function (v) {p[v.type] = Number(v.value);});
    var today = new Date(Date.UTC(p.year,p.month-1,p.day));
    var base = new Date(today); var after = p.hour >= 23;
    if (after) base.setUTCDate(base.getUTCDate()+1);
    var days = windowFor(country);
    function add(count) {
      var result = new Date(base);
      while (count > 0) {
        result.setUTCDate(result.getUTCDate()+1);
        var day = result.getUTCDay();
        if (day !== 0 && !(weekdaysOnly && country !== 'NL' && day === 6)) count--;
      }
      return result;
    }
    return {min:days[0],max:days[1],first:add(days[0]),last:add(days[1]),today:today,after:after};
  }
  // Export only for isolated deterministic tests; the browser has no external API or visitor detection.
  if (typeof module !== 'undefined' && module.exports) {module.exports={calculate:calculate,windowFor:windowFor}; return;}
  function refresh() {
    document.querySelectorAll('[data-delivery]').forEach(function (el) {
      try {
        var d = calculate(el.dataset.country,new Date(),el.dataset.weekdays === 'true');
        var locale = el.dataset.locale || document.documentElement.lang || 'en';
        var fmt = new Intl.DateTimeFormat(locale,{timeZone:'UTC',weekday:'long',day:'numeric',month:'long'});
        var last = fmt.format(d.last); var output = el.querySelector('[data-delivery-text]');
        var note = el.querySelector('[data-delivery-note]');
        var heading = el.dataset.latest.replace('[date]',last);
        var next = new Date(d.today); next.setUTCDate(next.getUTCDate()+1);
        var message = el.dataset.range.replace('[min]',d.min).replace('[max]',d.max);
        if (el.dataset.country === 'NL') {
          message = d.after ? el.dataset.after : d.last.getTime() === next.getTime() ? el.dataset.before : el.dataset.weekend;
          message = message.replace('[date]',last);
        }
        if (output && output.textContent !== heading) output.textContent = heading;
        if (note && note.textContent !== message) note.textContent = message;
        el.dataset.latestDate = d.last.toISOString().slice(0,10);
      } catch (_) { /* Keep translated, honest delivery-day fallback if Intl is unavailable. */ }
    });
  }
  function start() {
    refresh();
    new MutationObserver(function(records){
      if(records.some(function(r){return Array.from(r.addedNodes).some(function(n){return n.nodeType===1 && (n.matches('[data-delivery]') || n.querySelector('[data-delivery]'));});})) refresh();
    }).observe(document.documentElement,{childList:true,subtree:true});
    ['shopify:section:load','cart:refresh','cart:change','pw:cart-reconciled'].forEach(function(e){document.addEventListener(e,refresh);});
    document.addEventListener('visibilitychange',function(){if(!document.hidden)refresh();});
    window.addEventListener('pageshow',refresh);
    setInterval(refresh,30000);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
